export const SAVE_DRAFT_MESSAGE = 'app/javascript/common/constants/chat/SAVE_DRAFT_MESSAGE';

export const CHAT_ATTACHMENT_TYPE = {
  IMAGE: 'Image',
  DOCUMENT: 'Document',
};



// WEBPACK FOOTER //
// ./app/javascript/common/constants/chat.js